import { usePlaybackCurrentTs, usePlaybackPause } from '@app/core/playback/hooks/usePlayback';
import { Box, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';

/**
 * Button to select the current video frame.
 */
export function FrameSetButton({ onSelect }: { onSelect: (time: number | null) => void }) {
  const currentTs = usePlaybackCurrentTs();
  const pause = usePlaybackPause();

  return (
    <Box>
      <Button
        color={'primary'}
        variant="outlined"
        size="small"
        onClick={() => {
          pause();

          // Wait for videojs to pause before getting the time
          setImmediate(() => {
            onSelect(Math.round(currentTs ?? 0));
          });
        }}
      >
        <FormattedMessage
          id="common.frameSelector.useThisFrame"
          defaultMessage="Utilizar este frame"
        />
      </Button>
    </Box>
  );
}
